<template>
<div id="mainBlock">
    <div id="blackPanel"></div>
    <article>
        <section>
            <div id="subHeader">
                <h2 v-if="siteInfo !== null">{{siteInfo[0]['site_name']}}</h2>
                <Alert
                    ref="Alert"
                    :message="alertMessage"
                    :subMessage="alertSubMessage"
                    :errorFlag="errorFlag"
                    @confirmFinished="confirmFinished"
                />
            </div>
        </section>
        <div v-if="settingCamLists">
            <div class="setting-area">
                <div class="setting-menu">
                    <ul class="setting-ul" @click="showCamSetting = !showCamSetting">
                        <li class="setting-li" :id="list.idName" v-for="list in settingmenus" :key="list.objNum">
                            <router-link class="settingRouter" :id="list.idNum" :to="list.routerLink">
                                <p class="setting-name">{{list.name}}</p>
                                <p class="setting-detail">{{list.details}}</p>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </article>
</div>
</template>
<script>
const logoutUrl = process.env.VUE_APP_LOGOUT;
import Alert from '../modal/Alert'

export default {
    name: 'SettingMain',
    data(){
        return {
            settingmenus: [
                // {objNum:1, idName: "basic-setting", idNum: "settingmenus-1", routerLink:'/settings/basic?site_no=' + this.$store.getters['auth/getSiteNo'], name:'基本設定', details: '基本的な画面の設定をします。'},
                {objNum:2, idName: "camera-setting", idNum: "settingmenus-2", routerLink:'/settings/camera?site_no=' + this.$store.getters['auth/getSiteNo'], name:'カメラ設定', details: 'カメラの基本設定をします。'},
                // {objNum:3, idName: "other-setting", idNum: "settingmenus-3", routerLink:'/settings/cameradetails', name:'その他設定', details: 'その他の設定をします。'}
            ],
            alertMessage: '',
            alertSubMessage: '',
            errorFlag: false,
            showCamSetting: true,
        }
    },
    props:{
        siteInfo:{
            type: Array
        }
    },
    methods:{
        showResultMessage(result) {
            this.$refs.Alert.showConfirm();
            this.alertMessage = result.message;
            this.alertSubMessage = result.sub_message;
            this.conrfirmResult = result
            this.errorFlag = result.errorFlag;
        },
        confirmFinished() {
            if (this.conrfirmResult.transitionLogoutPageFlg) {
                sessionStorage.clear();
                window.location.href = logoutUrl;
            }
            if (this.conrfirmResult.transitionTopPageFlg) {
                window.location.href = '/home?site_no=' + this.$store.getters['auth/getSiteNo'];
            }
            if (this.conrfirmResult.execFlg) {
                this.getThumnailImageInfo();
            }
        }
    },
    computed: {
        //*********************************************************/
        // 権限による設定画面の表示非表示
        /**********************************************************/
        settingCamLists() {
            return this.$userRoleAuthorization('setting', 'settingCamLists');
        },
    },
    mounted: function(){
        //*********************************************************/
        // 画面描写後にローディングをはずす
        /**********************************************************/
        this.$emit('loadFinish');

        //*********************************************************/
        // 権限がない場合にログアウト画面にリダイレクトする処理
        /**********************************************************/
        if(!this.$userRoleAuthorization('setting', 'settingCamLists')){
            this.showResultMessage({
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: true,
                execFlg: false,
                message:"権限エラー",
                sub_message:"アクセス権がありません。",
                errorFlag: true
            });
        }
    },
    components: {
        Alert,
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main/SettingMain.css";
</style>